// EY60LAA

import { Flex, SimpleGrid } from "@chakra-ui/react";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useLocation, useNavigate } from "react-router-dom";
import { ToggleSwitch } from "components/ToggleSwitch";
import { useEffect, useState } from "react";
import { Header } from "components/Header";
import { api } from "services/api";
import { toaster } from "components/ui/toaster";
import utils from "utils";
import InputComp from "components/InputComp";
import ButtonComp from "components/Button";
import Layout from "components/Layout";

// const fs = "sm";

function VehicleDetails() {
  // menualy
  const [isLoading, setIsLoading] = useState(false);
  const [fueltypes, setFueltypes] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const action = location?.state?.action;
  const itemData = location?.state?.data;
  const ismobile = useCheckMobileScreen();

  // const [address1, setAddress1] = useState(itemData?.address1 || "");
  // const [address2, setAddress2] = useState(itemData?.address2 || "");
  // const [address3, setAddress3] = useState(itemData?.address3 || "");
  // const [company, setCompany] = useState(itemData?.company || "");
  // const [country, setCountry] = useState(itemData?.country || "");
  // const [email, setEmail] = useState(itemData?.email || "");
  // const [forename, setForename] = useState(itemData?.forename || "");
  // const [hometel, setHometel] = useState(itemData?.hometel || "");
  // const [mobile, setMobile] = useState(itemData?.mobile || "");
  // const [policyid, setPolicyid] = useState(itemData?.policyid || "");
  // const [policynumber, setPolicynumber] = useState(
  // itemData?.policynumber || ""
  // );
  // const [postcode, setPostcode] = useState(itemData?.postcode || "");
  // const [surname, setSurname] = useState(itemData?.surname || "");
  // const [title, setTitle] = useState(itemData?.title || "");
  // const [town, setTown] = useState(itemData?.town || "");
  // const [recordtype, setRecordtype] = useState(itemData?.recordtype || "");
  // const [branchid, setBranchid] = useState(itemData?.branchid || "");
  // const [branchname, setBranchname] = useState(itemData?.branchname || "");
  // const [dateseconds, setDateseconds] = useState(itemData?.dateseconds || "");
  // const [coverid, setCoverid] = useState(itemData?.coverid || "");
  // const [operator, setOperator] = useState(itemData?.operator || "");
  // const [state, setState] = useState(itemData?.state || "");
  // const [datepolicy, setDatepolicy] = useState(itemData?.datepolicy || "");
  // const [invoiceid, setInvoiceid] = useState(itemData?.invoiceid || "");
  // const [nett, setNett] = useState(itemData?.nett || "");
  // const [tax, setTax] = useState(itemData?.tax || "");
  // const [gross, setGross] = useState(itemData?.gross || "");
  // const [invoicenumber, setInvoicenumber] = useState(
  // itemData?.invoicenumber || ""
  // );
  // const [vatpercent, setVatpercent] = useState(itemData?.vatpercent || "");
  // const [county, setCounty] = useState(itemData?.county || "");
  // const [poladmincosttype, setPoladmincosttype] = useState(
  // itemData?.poladmincosttype || ""
  // );
  // const [poladmincostcent, setPoladmincostcent] = useState(
  // itemData?.poladmincostcent || ""
  // );
  // const [poladmincostamt, setPoladmincostamt] = useState(
  // itemData?.poladmincostamt || ""
  // );
  // const [pricepaid, setPricepaid] = useState(itemData?.pricepaid || "");
  // const [deposit, setDeposit] = useState(itemData?.deposit || "");
  // const [notifyemail, setNotifyemail] = useState(itemData?.notifyemail || "");
  // const [policycommissionaccount, setPolicycommissionaccount] = useState(
  // itemData?.policycommissionaccount || ""
  // );
  // const [policycommissiontype, setPolicycommissiontype] = useState(
  // itemData?.policycommissiontype || ""
  // );
  // const [policycommissionamt, setPolicycommissionamt] = useState(
  // itemData?.policycommissionamt || ""
  // );
  // const [policycommissioncent, setPolicycommissioncent] = useState(
  // itemData?.policycommissioncent || ""
  // );
  // const [policycommissionvalue, setPolicycommissionvalue] = useState(
  //   itemData?.policycommissionvalue || ""
  // );
  // const [policycommissionpaytype, setPolicycommissionpaytype] = useState(
  //   itemData?.policycommissionpaytype || ""
  // );
  // const [vatcalculation, setVatcalculation] = useState(
  //   itemData?.vatcalculation || ""
  // );
  // const [policyrefundtype, setPolicyrefundtype] = useState(
  //   itemData?.policyrefundtype || ""
  // );
  // const [policyrefundvalue, setPolicyrefundvalue] = useState(
  //   itemData?.policyrefundvalue || ""
  // );
  // const [policyrefundduration, setPolicyrefundduration] = useState(
  //   itemData?.policyrefundduration || ""
  // );
  // const [refunddone, setRefunddone] = useState(itemData?.refunddone || "");
  // const [taxadmin, setTaxadmin] = useState(itemData?.taxadmin || "");
  // const [dateexpiry, setDateexpiry] = useState(itemData?.dateexpiry || "");
  // const [renewnotified, setRenewnotified] = useState(
  //   itemData?.renewnotified || ""
  // );
  // const [accepted, setAccepted] = useState(itemData?.accepted || "");
  // const [customersent, setCustomersent] = useState(
  //   itemData?.customersent || ""
  // );
  // const [customerstripeid, setCustomerstripeid] = useState(
  //   itemData?.customerstripeid || ""
  // );
  const [carmake, setCarmake] = useState(itemData?.carmake || "");
  const [carmodel, setCarmodel] = useState(itemData?.carmodel || "");
  // const [cartype, setCartype] = useState(itemData?.cartype || "");
  const [enginecapacity, setEnginecapacity] = useState(
    itemData?.enginecapacity || ""
  );
  const [fourbyfour, setFourbyfour] = useState(
    itemData?.fourbyfour ? true : false
  );
  const [fueltype, setFueltype] = useState([]);
  const [luxury, setLuxury] = useState(itemData?.luxury ? true : false);
  const [mileage, setMileage] = useState(itemData?.mileage || "");
  const [purchaseprice, setPurchaseprice] = useState(
    itemData?.purchaseprice || ""
  );
  const [specialist, setSpecialist] = useState(
    itemData?.specialist ? true : false
  );
  // const [transmission, setTransmission] = useState(
  // itemData?.transmission || ""
  // );
  // const [vin, setVin] = useState(itemData?.vin || "");
  const [vrm, setVrm] = useState(itemData?.vrm || "");
  // const [vehicleid, setVehicleid] = useState(itemData?.vehicleid || "RE15VNY");
  // const [extranum, setExtranum] = useState(itemData?.extranum || "");
  const [datepurchase, setDatepurchase] = useState(itemData?.datepurchase);
  const [datereg, setDatereg] = useState(itemData?.datereg);
  // const [policynumber, setPolicynumber] = useState(itemData?.policynumber || '');
  const [carcolour, setCarcolour] = useState(itemData?.carcolour || "");
  // const [policyidvehicle, setPolicyidvehicle] = useState(
  // itemData?.policyidvehicle || ""
  // );
  // const [guaranteeid, setGuaranteeid] = useState(itemData?.guaranteeid || "");
  // const [startdate, setStartdate] = useState(itemData?.startdate || "");
  // const [covertype, setCovertype] = useState(itemData?.covertype || "");
  // const [vehiclecategory, setVehiclecategory] = useState(
  // itemData?.vehiclecategory || ""
  // );
  // const [durationid, setDurationid] = useState(itemData?.durationid || '');
  // const [mileageband, setMileageband] = useState(itemData?.mileageband || "");
  // const [dpfs, setDpfs] = useState(itemData?.dpfs || "");
  // const [higherlabourrate, setHigherlabourrate] = useState(
  // itemData?.higherlabourrate || ""
  // );
  // const [weartear, setWeartear] = useState(itemData?.weartear || "");
  // const [egrvalves, setEgrvalves] = useState(itemData?.egrvalves || "");
  // const [catalyticconverter, setCatalyticconverter] = useState(
  // itemData?.catalyticconverter || ""
  // );
  // const [retailprice, setRetailprice] = useState(itemData?.retailprice || "");
  // const [policynumber, setPolicynumber] = useState(itemData?.policynumber || '');
  // const [claimlimitamount, setClaimlimitamount] = useState(
  // itemData?.claimlimitamount || ""
  // );
  // const [claimlimitid, setClaimlimitid] = useState(
  // itemData?.claimlimitid || ""
  // );
  // const [coverid, setCoverid] = useState(itemData?.coverid || '');
  // const [startdateseconds, setStartdateseconds] = useState(
  // itemData?.startdateseconds || ""
  // );
  // const [policyidguarantee, setPolicyidguarantee] = useState(
  // itemData?.policyidguarantee || ""
  // );
  // const [durationid, setDurationid] = useState(itemData?.durationid || "");
  // const [durationtype, setDurationtype] = useState(
  // itemData?.durationtype || ""
  // );
  // const [active, setActive] = useState(itemData?.active || "");
  // const [hide, setHide] = useState(itemData?.hide || "");
  // const [durationvalue, setDurationvalue] = useState(
  // itemData?.durationvalue || ""
  // );

  const genData = () => {
    return {
      ...itemData,
      carmake,
      carmodel,
      cartype: "",
      carcolour,
      enginecapacity,
      fueltype,
      datereg,
      regdate: datereg ? utils.yyyymmddToDbSec(datereg) : 0,
      datepurchase,
      purchasedate: datepurchase ? utils.yyyymmddToDbSec(datepurchase) : 0,
      mileage,
      purchaseprice,
      fourbyfour,
      luxury,
      specialist,
      transmission: "",
      vrm: vrm,
      // title: title,
    };
  };

  const clearForm = () => {
    setCarmake("");
    setCarmodel("");
    setEnginecapacity("");
    setFourbyfour(false);
    setFueltype("");
    setLuxury("");
    setMileage("");
    setPurchaseprice("");
    setSpecialist(false);
    setVrm("");
    setDatepurchase("");
    setDatereg("");
    setCarcolour("");
    getFueltype();

    // setCarmake(itemData?.carmake || "");
    // setCarmodel(itemData?.carmodel || "");
    // setEnginecapacity(itemData?.enginecapacity || "");
    // setFourbyfour(itemData?.fourbyfour || "");
    // setFueltype(itemData?.fueltype || "");
    // setLuxury(itemData?.luxury || "");
    // setMileage(itemData?.mileage || "");
    // setPurchaseprice(itemData?.purchaseprice || "");
    // setSpecialist(itemData?.specialist || "");
    // setVrm(itemData?.vrm || "");
    // setDatepurchase(itemData?.datepurchase || "");
    // setDatereg(itemData?.datereg || "");
    // setCarcolour(itemData?.carcolour || "");
    // setMileageband(itemData?.mileageband || "");
  };

  const onNext = () => {
    let errMsg = false;

    if (errMsg === false && !vrm) {
      errMsg = "vrm";
    }

    if (errMsg === false && !carmake) {
      errMsg = "carmake";
    }

    if (errMsg === false && !carmodel) {
      errMsg = "carmodel";
    }

    if (errMsg === false && !carcolour) {
      errMsg = "carcolour";
    }

    if (errMsg === false && !enginecapacity) {
      errMsg = "enginecapacity";
    }

    if (errMsg === false && !fueltype) {
      errMsg = "fueltype";
    }

    if (errMsg === false && !datereg) {
      errMsg = "Registration Date";
    }

    // if (errMsg === false && !datepurchase) {
    //   errMsg = "datepurchase";
    // }

    // if (errMsg === false && !mileage) {
    //   errMsg = "mileage";
    // }

    // if (errMsg === false && !purchaseprice) {
    //   errMsg = "purchaseprice";
    // }

    if (errMsg) {
      toaster.create({
        title: "enter valid " + errMsg,
        type: "error",
      });
      return;
    }

    console.log("action  2", action);

    navigate("/guarantee", {
      state: {
        action: "agreement-edit-3",
        data: genData(),
      },
    });
  };

  const onPrev = () => {
    navigate("/agreementsadd", {
      state: {
        action: "agreement-edit",
        data: genData(),
      },
    });
  };

  const onClose = () => {
    navigate("/agreements", {
      state: {},
    });
  };

  const setLookupData = (data) => {
    // setAddressList(res.data);
    // setIsModalOpen(true);

    setCarmake(data.Make);
    setCarmodel(data.Model);
    setCarcolour(data.Colour);
    setEnginecapacity(data.CylinderCapacity);
    // setFueltype(data.Fuel);
    setDatereg(data.DateOfRegistration);

    let item;
    let indexF;
    let arr = fueltype;
    if (fueltypes && fueltypes[0] && data?.Fuel) {
      arr = fueltypes?.map((a, index) => {
        if (a?.data?.fueltype === data?.Fuel) {
          a.selected = true;
          item = a;
          indexF = index;
        } else {
          a.selected = false;
        }
        return a;
      });
    }

    onChangeFueltypes({
      item: item,
      list: arr,
      index: indexF,
    });

    // setDatepurchase();
    // setMileage(vd.MotQtyRecordedInMiles)
  };

  const onClickLookup = () => {
    if (isLoading || !vrm) return;
    setIsLoading(true);
    api.getVehicledata({ regnumber: vrm }).then((res) => {
      console.log("getVehicledata res", res);

      if (res.status === 200) {
        if (res.data?.Success) {
          const vd = res?.data?.VehicleDetails;

          api.getFueltypeexists({ fueltype: vd.Fuel }).then((res1) => {
            console.log("getVehicledata res1", res1);
            if (res1.status === 200) {
              if (res1?.data?.found === true || res1.data?.found === "true") {
                setIsLoading(false);
                setLookupData(vd);
              } else {
                api.addFueltype({ fueltype: vd.Fuel }).then((res2) => {
                  console.log("getVehicledata res2", res2);
                  if (res2.status === 200) {
                    // getFueltype({ default: vd.Fuel });
                    getFueltype({ default: vd.Fuel }).then(() => {
                      setIsLoading(false);
                    });
                  } else {
                    setIsLoading(false);
                    toaster.create({
                      title: res2?.message || "vehicle data database error",
                      type: "error",
                    });
                  }
                });
              }
            } else {
              setIsLoading(false);
              toaster.create({
                title: res1?.message || "vehicle data not found",
                type: "error",
              });
            }
          });
        } else {
          setIsLoading(false);
          toaster.create({
            title: res?.message || "vehicle data not found",
            type: "error",
          });
        }
      } else {
        setIsLoading(false);
        toaster.create({
          title: res?.message || "error find vehicle data",
          type: "error",
        });
      }
    });
  };

  const onChangeFueltypes = (data) => {
    console.log("onChangeFueltypes", data);

    setFueltypes(data?.list ? [...data.list] : []);
    setFueltype(data?.item?.data?.fueltype || "");
    // setBranchname(data?.item?.label);
    // getPolicyTypes({ dealerid: data?.item?.data?.dealerid });
  };

  const getFueltype = (data) => {
    setIsLoading(true);

    api.getFueltype().then((res) => {
      console.log("getFueltype =", res);
      setIsLoading(false);
      if (res?.status === 200) {
        if (res?.data && res?.data[0]) {
          let arr = res.data.map((a, index) => ({
            key: `fueltype-${index}`,
            value: `${a.fueltype}-${index}`,
            label: a.fueltype,
            data: a,
          }));

          if (
            data?.default ||
            (data?.action === "useState" && itemData?.fueltype)
          ) {
            let item = {};
            let index = 0;

            arr = arr.map((a, inx) => {
              if (
                a.data.fueltype === data.default ||
                a.data.fueltype === itemData.fueltype
              ) {
                index = inx;
                a.selected = true;
                item = a;
              } else {
                a.selected = false;
              }
              return a;
            });

            // arr[0].selected = true;
            onChangeFueltypes({
              index: index,
              item: item,
              list: arr,
            });
          } else {
            // arr[0].selected = true;
            onChangeFueltypes({
              // item: arr[0],
              list: arr,
              // index: 0,
            });
          }
        }
      } else {
        toaster.create({
          title: res?.message || "fail",
          type: "error",
        });
      }
    });
  };

  useEffect(() => {
    console.log("useEffect itemData", itemData);
    getFueltype({ action: "useState" });
    // setDatepurchase(utils.dateToDateInput(itemData?.datepurchase));
    if (itemData?.datereg) {
      setDatereg(utils.dateToDateInput(itemData?.datereg));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      {/* <Flex flex={1} direction={"column"}> */}

      <Header
        label={`Vehicle Details${
          action === "agreement-edit-2"
            ? `${itemData?.policynumber ? " - " + itemData?.policynumber : ""}`
            : ""
        }`}
        isLoading={isLoading}
      />
      <Layout>
        {/* </Flex>

        <SimpleGrid
          columns={ismobile ? 1 : 2}
          columnGap="1rem"
          rowGap="1rem"
          mt="1rem"
          // maxWidth={"25rem"}
        >
        </SimpleGrid>
         */}

        <SimpleGrid
          columns={ismobile ? 1 : 2}
          columnGap="1rem"
          rowGap="1rem"
          mt="1rem"
          // maxWidth={"25rem"}
        >
          <InputComp
            type="vrm-comp"
            label={"Registration"}
            value={vrm}
            onChange={setVrm}
            required={true}
          />

          <Flex alignItems={"center"} gap={"1rem"}>
            <ButtonComp
              // w={width1}
              // bg="text"
              // textStyle={fs}
              onClick={onClickLookup}
              label="Lookup"
              keyname="lookup"
              disabled={isLoading}
            />
            {action === "managecar" ? null : (
              <ButtonComp
                label={"Clear"}
                onClick={clearForm}
                keyname={"clear"}
                disabled={isLoading}
              />
            )}
          </Flex>

          <InputComp
            label={"Make"}
            value={carmake}
            onChange={setCarmake}
            required={true}
          />

          <InputComp
            label={"Model"}
            value={carmodel}
            onChange={setCarmodel}
            required={true}
          />

          <InputComp
            label={"Colour"}
            value={carcolour}
            onChange={setCarcolour}
            required={true}
          />

          <InputComp
            label={"Engine Capacity (CC)"}
            type="number"
            value={enginecapacity}
            onChange={setEnginecapacity}
            required={true}
          />

          <InputComp
            label={"Fuel Type"}
            items={fueltypes}
            onChange={onChangeFueltypes}
            placeholder={"Select Fuel Type"}
            type={"dropdown"}
            required={true}
          />

          <InputComp
            label={"Registration Date"}
            type="date"
            value={datereg}
            onChange={setDatereg}
            required={true}
          />

          <InputComp
            label={"Purchase Date"}
            type="date"
            value={datepurchase}
            onChange={setDatepurchase}
            required={false}
          />

          <InputComp
            label={"Mileage"}
            type="number"
            value={mileage}
            onChange={setMileage}
            required={false}
          />

          <InputComp
            label={"Purchase Price"}
            type="number"
            value={purchaseprice}
            onChange={setPurchaseprice}
            required={false}
          />

          {/* <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>
            Make <Field.Label color={"red"}>*</Field.Label>
          </Field.Label>
          <Input
            type="text"
            value={carmake}
            onChange={(e) => setCarmake(e.currentTarget.value)}
            textStyle={"md"}
          />
        </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>
            Model <Field.Label color={"red"}>*</Field.Label>
          </Field.Label>
          <Input
            type="text"
            value={carmodel}
            onChange={(e) => setCarmodepurchasedatel(e.currentTarget.value)}
            textStyle={"md"}
          />
        </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>
            Colour <Field.Label color={"red"}>*</Field.Label>{" "}
          </Field.Label>
          <Input
            type="text"
            value={carcolour}
            onChange={(e) => setCarcolour(e.currentTarget.value)}
            textStyle={"md"}
          />
        </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>
            Engine Capacity (CC) <Field.Label color={"red"}>*</Field.Label>
          </Field.Label>
          <Input
            type="number"
            value={enginecapacity}
            onChange={(e) => setEnginecapacity(e.currentTarget.value)}
            textStyle={"md"}
          />
        </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>
            Fuel Type <Field.Label color={"red"}>*</Field.Label>
          </Field.Label>
          <DropDown
            w={"100%"}
            textStyle={fs}
            items={fueltypes}
            onChange={onChangeFueltypes}
            placeholder={"Select Fuel Type"}
          />
        </Field.Root> */}
          {/* <Flex maxWidth={"15rem"}>
          <Field.Root orientation="horizontal" gap={4} required>
            <Field.Label textStyle={fs}>
              Registration Date <Field.RequiredIndicator />
            </Field.Label>
            <Input
              type="date"
              value={utils.dateToDateInput(datereg)}
              onChange={(e) => setDatereg(e.currentTarget.value)}
              textStyle={"md"}
            />
          </Field.Root>
        </Flex> */}

          {/* <Flex maxWidth={"15rem"}>
          <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Purchase Date</Field.Label>
            <Input
              type="date"
              value={utils.dateToDateInput(datepurchase)}
              onChange={(e) => setDatepurchase(e.currentTarget.value)}
              textStyle={"md"}
            />
          </Field.Root>
        </Flex> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>Mileage</Field.Label>
          <Input
            type="number"
            value={mileage}
            onChange={(e) => setMileage(e.currentTarget.value)}
            textStyle={"md"}
          />
        </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
          <Field.Label textStyle={fs}>Purchase Price</Field.Label>
          <Input
            type="number"
            value={purchaseprice}
            onChange={(e) => setPurchaseprice(e.currentTarget.value)}
            textStyle={"md"}
          />
        </Field.Root> */}
        </SimpleGrid>

        <Flex direction={"column"} gap={"1rem"} mt={"1rem"}>
          <Flex
            flexFlow={"wrap"}
            // orientation={ismobile ? "vertical" : "horizontal"}
            gap={"1rem"}
            mt={"1rem"}
          >
            <ToggleSwitch
              label={"4x4"}
              value={fourbyfour}
              onChange={setFourbyfour}
            />
            <ToggleSwitch
              label={"Luxury"}
              value={luxury}
              onChange={setLuxury}
            />
            <ToggleSwitch
              label={"Specialist"}
              value={specialist}
              onChange={setSpecialist}
            />
            {/* <Flex>
        <Field.Label textStyle={fs}></Field.Label>
        <ToggleSwitch label={"Luxury"} />
      </Flex> */}
            {/* <Field.Root orientation="horizontal" gap={4}> */}
            {/* </Field.Root> */}
          </Flex>
        </Flex>
        {/* </Flex> */}
      </Layout>
      {action === "managecar" ? (
        <Flex
          // direction={ismobile ? "column" : "row"}
          // justifyContent="space-between"
          // alignItems="center"
          // mt={"1rem"}
          alignItems={"center"}
          justify={"space-between"}
          gap={"1rem"}
          wrap={"wrap"}
        >
          <ButtonComp label={"Clear"} onClick={clearForm} keyname={"clear"} />
          <ButtonComp label={"Save"} onClick={onNext} keyname={"save"} />
        </Flex>
      ) : (
        <Flex
          // direction={ismobile ? "column" : "row"}
          // justifyContent="space-between"
          // alignItems="center"
          // mt={"1rem"}
          alignItems={"center"}
          justify={"space-between"}
          gap={"1rem"}
          wrap={"wrap"}
        >
          <ButtonComp label={"Close"} onClick={onClose} keyname={"close"} />
          <Flex flex={1} bg={"red"} />
          {/* <Flex gap={"1rem"} mt={"1rem"} alignItems={"center"}> */}
          <ButtonComp label="Previous" onClick={onPrev} keyname="prev" />
          <ButtonComp label="Next" onClick={onNext} keyname="next"  disabled={isLoading} />
          {/* <Button bg="fontdark" textStyle={"sm"}>
              Lookup
            </Button> */}
          {/* </Flex> */}
        </Flex>
      )}
    </Flex>
  );
}

export default VehicleDetails;
